// extracted by mini-css-extract-plugin
export var bar = "info-bars-module--bar--c7437";
export var container = "info-bars-module--container--ef456";